var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.122,
    height: 23.387,
    viewBox: "0 0 28.122 23.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(-5151.217 -1941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6407",
    "data-name": "Path 6407",
    d: "M5174.038,1942.287a2.181,2.181,0,0,0-2.29-1.181l-18.035-.106h0a2.311,2.311,0,0,0-1.806,3.937c2.633,3.112,4.817,5.7,6.913,8.217.042.05.025.176.006.3a1.371,1.371,0,0,0-.023.251c.008,1.523-.1,3.084-.159,4.6-.05,1.392-.157,2.832-.157,4.224v.585a1.407,1.407,0,0,0,.811,1.166,1.618,1.618,0,0,0,.587.115,1.6,1.6,0,0,0,.932-.385l.809-.583c1.329-1,2.725-2.042,4.144-3.093a1.361,1.361,0,0,0,.606-1.2c-.013-1.822-.009-3.63.012-5.367a.841.841,0,0,1,.171-.479c.938-1.126,1.913-2.309,2.853-3.452,1.362-1.659,2.773-3.373,4.171-5.026A2.182,2.182,0,0,0,5174.038,1942.287Zm-9.711,16.165c0,.184.007.263-.139.37l-3.823,3.3.593-8.628a2.051,2.051,0,0,0-.5-1.459c-1.889-2.225-3.8-4.516-5.594-6.658l0-.006v0l-1.4-1.463a1.847,1.847,0,0,1-.206-.278.339.339,0,0,1,.235-.491l18.392.023c.281,0,.3.094.324.138a.435.435,0,0,1-.1.491c-.439.539-.895,1.026-1.336,1.5-.374.4-.761.811-1.134,1.256-.142.167-.282.334-.425.5l-.344.412-.982,1.166c-1.132,1.35-2.158,2.535-3.08,3.619a1.748,1.748,0,0,0-.5,1.179Z",
    transform: "translate(0 0)",
    fill: "#cc0e2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(5171.397 1950)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6408",
    "data-name": "Path 6408",
    d: "M5250.941,1987.836a.833.833,0,0,1-.689.821c-.023,0-.048.009-.071.01s-.05,0-.075,0h-6.27c-.025,0-.05,0-.075,0s-.048-.006-.071-.01a.835.835,0,0,1,.146-1.657h6.27A.835.835,0,0,1,5250.941,1987.836Z",
    transform: "translate(-5243 -1987)",
    fill: "#cc0e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(5167.89 1954.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6409",
    "data-name": "Path 6409",
    d: "M5241.449,2005.836a.833.833,0,0,1-.689.821c-.023,0-.048.008-.071.01s-.05,0-.075,0h-8.778c-.025,0-.05,0-.075,0s-.048-.006-.071-.01a.835.835,0,0,1,.146-1.657h8.778A.836.836,0,0,1,5241.449,2005.836Z",
    transform: "translate(-5230 -2005.375)",
    fill: "#cc0e2d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(5167.89 1958.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6410",
    "data-name": "Path 6410",
    d: "M5241.449,2023.836a.833.833,0,0,1-.689.821c-.023,0-.048.008-.071.01s-.05,0-.075,0h-8.778c-.025,0-.05,0-.075,0s-.048-.006-.071-.01a.835.835,0,0,1,.146-1.657h8.778A.836.836,0,0,1,5241.449,2023.836Z",
    transform: "translate(-5230 -2023.136)",
    fill: "#cc0e2d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.4a44a535f9c926769c11fc6fb1831e58.svg";
export { ForwardRef as ReactComponent };